
import Notifications from 'vue-notification'

export default (Vue) => {
  Vue.use(Notifications)
}
